import { render, staticRenderFns } from "./Store.vue?vue&type=template&id=24635b32&scoped=true&"
import script from "./Store.vue?vue&type=script&lang=ts&"
export * from "./Store.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24635b32",
  null
  
)

export default component.exports